@if (showKilojoules() && sellable().kiloJoules) {
    <div class="kilojoules">
        {{ sellable().kiloJoules }} kJ
    </div>
}
@if (menuModel.currentMenu() && sellable().dietaryIndicators.length) {
    <div class="indicators">
        @for (indicator of sellable().dietaryIndicators; track indicator.id) {
            <div class="indicators-indicator" woa-touchable>
                <div class="indicators-indicator-tooltip" [ngClass]="{'left': tooltipLeft(icon, label)}" #label>
                    {{ indicator.name || indicator.code }}
                </div>
                <div class="indicators-indicator-icon" [class.lightTheme]="themeModel.isLightTheme()" #icon>
                    <div class="indicators-indicator-icon-text" [ngClass]="{'compressed': indicator.code.length > 2}">
                        {{ getDisplayedIndicatorCode(indicator) }}
                    </div>
                </div>
            </div>
        }
    </div>
}
